var React = require('react');

function CheckmarkStrokeLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M47.583.188a1 1 0 01.23 1.395l-33 46a1 1 0 01-1.52.124l-13-13a1 1 0 111.414-1.414L13.874 45.46 46.188.417a1 1 0 011.395-.23z"}));
}

CheckmarkStrokeLight.defaultProps = {"viewBox":"0 0 48 49"};

module.exports = CheckmarkStrokeLight;

CheckmarkStrokeLight.default = CheckmarkStrokeLight;
